module.exports = __webpack_public_path__ + "img/working_identity.3a70ae1c.jpg";